/**
 * Onthoudt welke Edu-V-exportconfiguraties deze gebruiker is tegengekomen
 * (alleen id + naam, géén leerling- of LAS-gegevens). Er is geen endpoint dat
 * configuraties los van een opname oplevert, dus de instellingenpagina
 * gebruikt deze lijst om te weten of de medewerker-koppeling relevant is om
 * te tonen.
 */
const STORAGE_KEY = 'notizy.eduv.knownConfigs';

export interface KnownEduVConfig {
    id: string;
    name: string;
}

export const getKnownEduVConfigs = (): KnownEduVConfig[] => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed
            .filter((item: any) => item && typeof item.id === 'string' && item.id !== '')
            .map((item: any) => ({
                id: item.id,
                name: typeof item.name === 'string' ? item.name : '',
            }));
    } catch {
        return [];
    }
};

/** Voegt nieuwe configuraties toe en ververst namen van bekende. */
export const rememberEduVConfigs = (configs: KnownEduVConfig[]): void => {
    if (configs.length === 0) return;
    try {
        const known = getKnownEduVConfigs();
        const byId = new Map(known.map((config) => [config.id, config]));
        configs.forEach((config) => {
            byId.set(config.id, { id: config.id, name: config.name });
        });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(byId.values())));
    } catch {
        // localStorage niet beschikbaar → sectie verschijnt gewoon niet.
    }
};

/** Voor als een configuratie niet meer bestaat (bijv. 404 op user-settings). */
export const forgetEduVConfig = (configId: string): void => {
    try {
        const remaining = getKnownEduVConfigs().filter((config) => config.id !== configId);
        if (remaining.length === 0) {
            localStorage.removeItem(STORAGE_KEY);
        } else {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(remaining));
        }
    } catch {
        // Negeren; hooguit blijft een verouderde entry staan.
    }
};
